const PERSON_NAME_PUNCTUATION = [' ', '-', '‘', '’', "'", '.', ',', '/', '&'];
const CITY_PUNCTUATION = [' ', '-', ',', '.', "'", '’'];
const STREET_ADDRESS_PUNCTUATION = [
  ' ',
  '-',
  '&',
  ';',
  ',',
  '.',
  '/',
  ':',
  '(',
  ')',
  "'",
  '’'
];

const LATIN_LETTER = /^(?=\p{L})\p{Script=Latin}$/u;
const DIGIT = /^\p{Nd}$/u;
const DASH_VARIANTS = /[\u2010-\u2015\u2212]/g;
const LEFT_SINGLE_QUOTE = /\u2018/g;
const DEGREE_SIGN = /\u00b0/g;

export const normalizeLatinText = (value: string) =>
  value
    .trim()
    .normalize('NFKC')
    .replace(DASH_VARIANTS, '-')
    .replace(LEFT_SINGLE_QUOTE, '\u2019');

const containsOnlyAllowedCharacters = (
  value: string,
  punctuation: string[],
  allowDigits: boolean
) =>
  Array.from(normalizeLatinText(value)).every(
    char =>
      punctuation.includes(char) ||
      (allowDigits && DIGIT.test(char)) ||
      LATIN_LETTER.test(char)
  );

export const isValidPersonName = (value: string) =>
  containsOnlyAllowedCharacters(value, PERSON_NAME_PUNCTUATION, false);

export const isValidCity = (value: string) =>
  containsOnlyAllowedCharacters(value, CITY_PUNCTUATION, false);

export const isValidStreetAddress = (value: string) =>
  containsOnlyAllowedCharacters(
    value.replace(DEGREE_SIGN, 'o'),
    STREET_ADDRESS_PUNCTUATION,
    true
  );
